var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { attrs: { flat: "", color: "transparent" } },
    [
      _c(
        "v-container",
        { attrs: { fluid: "" } },
        [
          _c(
            "v-row",
            {
              staticStyle: { "margin-top": "10px", "margin-bottom": "4px" },
              attrs: {
                "no-gutters": "",
                "align-content": "center",
                "justify-content": "start"
              }
            },
            [
              _c(
                "v-col",
                { attrs: { cols: "auto", "align-self": "center" } },
                [
                  _c(
                    "router-link",
                    {
                      staticStyle: { "text-decoration": "none" },
                      attrs: { to: { path: "/items" } }
                    },
                    [
                      _c(
                        "v-icon",
                        { staticClass: "mx-2", attrs: { color: "primary" } },
                        [_vm._v("\n            mdi-chevron-left\n          ")]
                      ),
                      _vm._v("Return to Items\n        ")
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider", { staticClass: "mx-5", attrs: { vertical: "" } }),
              _vm._v(" "),
              _c(
                "v-col",
                { attrs: { cols: "auto", "align-self": "center" } },
                [
                  _c(
                    "v-toolbar-title",
                    {
                      staticStyle: {
                        "padding-top": "0",
                        "padding-bottom": "0",
                        "padding-left": "0"
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.existingItem
                              ? "" + (_vm.item.description || "")
                              : "Create New"
                          ) +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-col",
                {
                  staticClass: "col-auto ml-auto",
                  attrs: { cols: "auto", "align-self": "center" }
                },
                [
                  _vm.existingItem && _vm.item.item_id
                    ? _c(
                        "v-card-subtitle",
                        {
                          staticClass: "text-capitalize text-body-1 pa-0",
                          staticStyle: { margin: "auto 10px 0 auto" }
                        },
                        [
                          _vm._v(
                            "\n          Id: " +
                              _vm._s(_vm.item.item_id) +
                              "\n        "
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        { staticStyle: { display: "grid", "min-height": "600px" } },
        [
          _c(
            "div",
            {
              staticStyle: {
                display: "grid",
                "align-content": "flex-start",
                margin: "0",
                padding: "0"
              }
            },
            [
              _c(
                "v-toolbar",
                {
                  staticStyle: { "background-color": "transparent" },
                  attrs: { flat: "" }
                },
                [
                  _c(
                    "v-card-title",
                    { staticClass: "py-0 pr-0" },
                    [
                      _c("v-icon", { attrs: { left: "" } }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.existingItem
                                ? "mdi-note-text-outline"
                                : "mdi-account"
                            ) +
                            "\n        "
                        )
                      ]),
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.existingItem ? "Item Details" : "Create Item"
                          ) +
                          "\n      "
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    {
                      staticClass: "d-flex justify-end align-center mr-2",
                      attrs: { cols: "auto" }
                    },
                    [
                      _c(
                        "v-card-subtitle",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.existingItem,
                              expression: "existingItem"
                            }
                          ],
                          staticClass: "ma-0 pa-0"
                        },
                        [_vm._v("\n          Hide Empty Fields\n        ")]
                      ),
                      _vm._v(" "),
                      _c("v-switch", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.existingItem,
                            expression: "existingItem"
                          }
                        ],
                        staticClass: "my-auto ml-4 mr-4",
                        attrs: {
                          color: "success",
                          disabled: _vm.loading || _vm.saving,
                          "hide-details": "",
                          dense: ""
                        },
                        model: {
                          value: _vm.hideEmpty,
                          callback: function($$v) {
                            _vm.hideEmpty = $$v
                          },
                          expression: "hideEmpty"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.hasWriteAccess,
                              expression: "hasWriteAccess"
                            }
                          ],
                          staticClass: "mr-0 pr-4",
                          style: _vm.showUpdateSources
                            ? "border-top-right-radius: 0px; border-bottom-right-radius: 0px; min-width: auto"
                            : null,
                          attrs: {
                            disabled: _vm.loading || _vm.saving,
                            loading: _vm.saving,
                            color: "success",
                            depressed: _vm.showUpdateSources
                          },
                          on: { click: _vm.saveItem }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.existingItem ? "Update" : "Create") +
                              "\n          " +
                              _vm._s(
                                _vm.updateSources.length > 0
                                  ? "(+" + _vm.updateSources.length + ")"
                                  : ""
                              ) +
                              "\n        "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm.showUpdateSources
                        ? [
                            _c("v-divider", {
                              attrs: { vertical: "", dark: "" }
                            }),
                            _vm._v(" "),
                            _c(
                              "v-menu",
                              {
                                attrs: {
                                  "offset-y": "",
                                  left: "",
                                  "close-on-content-click": false
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function(ref) {
                                        var on = ref.on
                                        var attrs = ref.attrs
                                        return [
                                          _c(
                                            "v-btn",
                                            _vm._g(
                                              {
                                                staticClass: "ml-0 px-2",
                                                staticStyle: {
                                                  "border-top-left-radius":
                                                    "0px",
                                                  "border-bottom-left-radius":
                                                    "0px",
                                                  "min-width": "auto"
                                                },
                                                attrs: {
                                                  color: "success",
                                                  depressed: "",
                                                  attrs: attrs,
                                                  disabled:
                                                    _vm.loading || _vm.saving
                                                }
                                              },
                                              on
                                            ),
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass: "pa-0 ma-0",
                                                  attrs: { dark: "" }
                                                },
                                                [_vm._v("mdi-chevron-down")]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  1590406560
                                )
                              },
                              [
                                _vm._v(" "),
                                _c(
                                  "v-card",
                                  { attrs: { flat: "", "min-width": "200" } },
                                  [
                                    _c(
                                      "v-list",
                                      { attrs: { dense: "", subheader: "" } },
                                      [
                                        _c(
                                          "v-list-item",
                                          [
                                            _c(
                                              "v-list-item-action",
                                              [
                                                _c("v-checkbox", {
                                                  model: {
                                                    value: _vm.updateAll,
                                                    callback: function($$v) {
                                                      _vm.updateAll = $$v
                                                    },
                                                    expression: "updateAll"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-list-item-content",
                                              [
                                                _c("v-list-item-title", [
                                                  _vm._v(
                                                    "\n                      All\n                    "
                                                  )
                                                ])
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("v-divider"),
                                        _vm._v(" "),
                                        _c(
                                          "v-list-item-group",
                                          {
                                            attrs: { multiple: "", dense: "" },
                                            model: {
                                              value: _vm.updateSources,
                                              callback: function($$v) {
                                                _vm.updateSources = $$v
                                              },
                                              expression: "updateSources"
                                            }
                                          },
                                          _vm._l(
                                            _vm.availableUpdateSources,
                                            function(source) {
                                              return _c("v-list-item", {
                                                key: source.source_id,
                                                attrs: {
                                                  value: source.source_id,
                                                  color: "primary"
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function(ref) {
                                                        var active = ref.active
                                                        return [
                                                          _c(
                                                            "v-list-item-action",
                                                            [
                                                              _c("v-checkbox", {
                                                                attrs: {
                                                                  "input-value": active
                                                                }
                                                              })
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-list-item-content",
                                                            [
                                                              _c(
                                                                "v-list-item-title",
                                                                [
                                                                  _vm._v(
                                                                    "\n                          " +
                                                                      _vm._s(
                                                                        source.source_name
                                                                      ) +
                                                                      "\n                        "
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  true
                                                )
                                              })
                                            }
                                          ),
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.hasWriteAccess && _vm.existingItem,
                              expression: "hasWriteAccess && existingItem"
                            }
                          ],
                          staticClass: "ml-4",
                          attrs: {
                            disabled:
                              _vm.loading ||
                              _vm.saving ||
                              _vm.availableCopySources.length === 0
                          },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              _vm.showCopyModal = true
                            }
                          }
                        },
                        [_vm._v("\n          Copy\n        ")]
                      )
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.loading
                ? [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "grid",
                          "justify-content": "center",
                          "align-content": "center",
                          padding: "50px",
                          "min-height": "100%",
                          "margin-top": "30px"
                        }
                      },
                      [
                        _c("v-progress-circular", {
                          attrs: { size: 50, color: "grey", indeterminate: "" }
                        })
                      ],
                      1
                    )
                  ]
                : [
                    _vm._l(_vm.currentSections, function(section) {
                      return [
                        _c("ItemData", {
                          key: section.fields,
                          ref: "item-" + section.fields,
                          refInFor: true,
                          attrs: {
                            title: section.title,
                            fields: section.fields,
                            crud: _vm.crud,
                            upcRes: _vm.upcRes,
                            hideEmpty: _vm.hideEmpty
                          },
                          on: {
                            upc: _vm.updateUpc,
                            resetUpcRes: function() {
                              return (_vm.upcRes = null)
                            }
                          },
                          model: {
                            value: _vm.editItem,
                            callback: function($$v) {
                              _vm.editItem = $$v
                            },
                            expression: "editItem"
                          }
                        })
                      ]
                    })
                  ]
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "v-container",
            {
              staticClass: "px-4",
              staticStyle: {
                display: "grid",
                "align-content": "flex-end",
                "margin-top": "auto"
              },
              attrs: { fluid: "" }
            },
            [
              _c(
                "v-row",
                { staticClass: "px-2 py-4" },
                [
                  _vm.existingItem && _vm.item.created_by
                    ? _c("v-col", { staticClass: "updated" }, [
                        _vm._v(
                          "\n          Created By: " +
                            _vm._s(_vm.item.created_by)
                        ),
                        _c("br"),
                        _vm._v(
                          "\n          Updated By: " +
                            _vm._s(_vm.item.last_update_user)
                        ),
                        _c("br"),
                        _vm._v(
                          "\n          Last Update: " +
                            _vm._s(
                              _vm.formatDates(_vm.item.last_update_date, true)
                            ) +
                            "\n        "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("v-col", {
                    staticClass: "d-flex justify-end",
                    attrs: { cols: "auto" }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.showCopyModal
        ? _c("ItemCopyModal", {
            attrs: {
              value: _vm.showCopyModal,
              item: _vm.item,
              availableCopySources: _vm.availableCopySources
            },
            on: {
              "update:value": function($event) {
                _vm.showCopyModal = $event
              },
              updateCopySources: _vm.findExistingSources
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-526f3912", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-526f3912","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/items/item.vue
// module id = null
// module chunks = 